import React from 'react'
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import default_banner_1 from "../../../images/banners/1.png";
import default_banner_2 from "../../../images/banners/2.png";
import default_banner_3 from "../../../images/banners/3.png";
import default_banner_4 from "../../../images/banners/4.png";
import default_banner_5 from "../../../images/banners/5.png";
import default_banner_6 from "../../../images/banners/6.png";
import { useSelector } from 'react-redux';
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const Banner = ({ banners }) => {
    const { data: realtorDetails } = useSelector(
        (state) => state.fetchRealtorDetails
    );
    return (
        <Swiper
            spaceBetween={30}
            centeredSlides={true}
            autoplay={{
                delay: 2500,
                disableOnInteraction: false,
            }}
            pagination={{
                clickable: true,
            }}
            navigation={true}
            modules={[Autoplay, Pagination, Navigation]}
            className="mySwiper"
        >
            <SwiperSlide>
                <a
                    href={
                        banners?.[0]?.ads_banner_url ||
                        "https://www.terminix.com/"
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <img
                        src={banners?.[0]?.ads_banner_image || default_banner_1}
                        alt="Banner 1"
                    />
                </a>
            </SwiperSlide>
            <SwiperSlide>
                <a
                    href={
                        banners?.[1]?.ads_banner_url ||
                        "https://www.stanleysteemer.com/"
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <img
                        src={banners?.[1]?.ads_banner_image || default_banner_2}
                        alt="Banner 2"
                    />
                </a>
            </SwiperSlide>
            <SwiperSlide>
                <a
                    href={
                        banners?.[2]?.ads_banner_url ||
                        "https://www.benjaminmoore.com/en-us"
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <img
                        src={banners?.[2]?.ads_banner_image || default_banner_3}
                        alt="Banner 3"
                    />
                </a>
            </SwiperSlide>
            <SwiperSlide>
                <a
                    href={banners?.[3]?.ads_banner_url || "https://ring.com/"}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <img
                        src={banners?.[3]?.ads_banner_image || default_banner_4}
                        alt="Banner 4"
                    />
                </a>
            </SwiperSlide>
            <SwiperSlide>
                <a
                    href={
                        banners?.[4]?.ads_banner_url ||
                        "https://www.homedepot.com/"
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <img
                        src={banners?.[4]?.ads_banner_image || default_banner_5}
                        alt="Banner 5"
                    />
                </a>
            </SwiperSlide>
            <SwiperSlide>
                <a
                    href={
                        banners?.[5]?.ads_banner_url ||
                        "https://www.rotorooter.com/"
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <img
                        src={banners?.[5]?.ads_banner_image || default_banner_6}
                        alt="Banner 6"
                    />
                </a>
            </SwiperSlide>
            {realtorDetails?.data?.realtor?.ads_banner_image && <SwiperSlide>
                <a
                    href={
                        realtorDetails?.data?.realtor?.ads_banner_url ||
                        "https://www.rotorooter.com/"
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <img
                        src={realtorDetails?.data?.realtor?.ads_banner_image || default_banner_6}
                        alt="Banner 7"
                    />
                </a>
            </SwiperSlide>}

        </Swiper>
    )
}

export default Banner